module.exports = __webpack_public_path__ + "static/img/6305_phase_function_Paper_PointsHejduk_Prediction.c2041ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6305_phase_function_Paper_PointsHejduk_Prediction.png
// module id = WiNB
// module chunks = 0